import FeatureGates from "@atlassian/feature-gate-js-client";
import { MeResponse } from "@atlassiansox/asc-stargate";

import { AvailableProductsResponse } from "@/libraries/bxp-web-stargate-client/src";
import { IntercomProvider } from "@/libraries/intercom/src";

import {
    JiraProductTourOverview,
    Atlas55799ProductTourOverview
} from "../../templates/jira-product-tour-overview/src/templates";

export type JiraSoftwarePageProps = {
    availableProducts: AvailableProductsResponse | null;
    userProfile: MeResponse | null;
};

export const JiraSoftwarePage = (props: JiraSoftwarePageProps) => {
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom: boolean = FeatureGates.checkGate(
        "gwp-737-enable-intercom-chat-jsw"
    );

    let template = (
        <JiraProductTourOverview
            availableProducts={props.availableProducts}
            userProfile={props.userProfile}
        />
    );

    // Atlas-55799: Jira Product Tour Overview Redesign for logged out users only
    if (!props?.userProfile) {
        const jiraPoductTourRedesign = FeatureGates.getExperimentValue(
            "jsw_product_tour_overview_redesign",
            "jira_product_tour_overview_redesign",
            false
        );

        if (jiraPoductTourRedesign) {
            template = <Atlas55799ProductTourOverview />;
        }
    }

    return (
        <IntercomProvider appId={"p0ww63i2"} triggerBoot={isBootIntercom}>
            {template}
        </IntercomProvider>
    );
};
